/**
 * @author  Agence Dn'D <contact@dnd.fr>
 * @license https://opensource.org/licenses/osl-3.0.php  Open Software License (OSL 3.0)
 * @link    https://www.dnd.fr/
 */

// Keeps the catalog form id created by the lead form, so the catalogs page can attach
// the catalogs the visitor downloads to the same request.
(() => {
    // Several sections load this file on the same page: register the click listener only once.
    if (window.sesaCatalogFormId) return;

    const FORM_ID_STORAGE_KEY = 'sesaCatalogFormId';
    const FORM_ID_TTL_MS = 30 * 60 * 1000; // 30 minutes

    function getStoredFormId() {
        try {
            const raw = window.localStorage.getItem(FORM_ID_STORAGE_KEY);
            if (!raw) return null;
            const { formId, expiresAt } = JSON.parse(raw);
            if (!formId || !expiresAt || Date.now() > expiresAt) {
                window.localStorage.removeItem(FORM_ID_STORAGE_KEY);
                return null;
            }
            return formId;
        } catch (e) {
            return null;
        }
    }

    function storeFormId(formId) {
        try {
            window.localStorage.setItem(
                FORM_ID_STORAGE_KEY,
                JSON.stringify({ formId, expiresAt: Date.now() + FORM_ID_TTL_MS })
            );
        } catch (e) {
            // localStorage unavailable (private mode, quota, etc.): formId simply won't persist across pages.
        }
    }

    // Attaches a downloaded catalog to the request created by the lead form. The link opens as usual:
    // keepalive lets the call outlive the navigation, and a failure must not block the download.
    function attach(title, url) {
        const formId = getStoredFormId();
        if (!formId) return;

        fetch(`${window.Sesa.appProxyPath}/document/download`, {
            method: 'POST',
            keepalive: true,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
            body: JSON.stringify({
                form: {
                    formId,
                    catalogs: [JSON.stringify({ title, url })]
                }
            })
        }).catch(() => {});
    }

    // Any link carrying data-catalog-title is a catalog download to attach.
    document.addEventListener('click', (event) => {
        const link = event.target.closest('a[href][data-catalog-title]');
        if (link) {
            attach(link.dataset.catalogTitle, link.href);
        }
    });

    window.sesaCatalogFormId = { get: getStoredFormId, set: storeFormId, attach };
})();
